<form 
  id="loginForm" 
  #loginForm="ngForm" 
  (ngSubmit)="onSubmit(loginForm)"
  >
<mat-card class="login-form">
  <mat-card-header class="title">
    <mat-card-title>Bienvenido! Sama App</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-form-field class="full-width">
      <mat-label>Usuario</mat-label>
      <input
        matInput
        #usernameInput="ngModel"
        [ngModel]="username$ | async"
        (ngModelChange)="onUsernameChange($event)"
        name="username"
        placeholder="Usuario"
        required
        email
        minlength="6"
      />
    </mat-form-field>

    <mat-form-field class="full-width">
      <mat-label>Contraseña</mat-label>
      <input
        matInput
        #passwordInput="ngModel"
        [ngModel]="password$ | async"
        (ngModelChange)="onPasswordChange($event)"
        name="password"
        [type]="isPasswordVisible ? 'text' : 'password'"
        placeholder="Contraseña"
        required
        minlength="4"
      />
      <mat-icon matSuffix (click)="isPasswordVisible = !isPasswordVisible">
        {{isPasswordVisible ? 'visibility_off' : 'visibility'}}
      </mat-icon>
    </mat-form-field>


  </mat-card-content>
  <mat-card-actions>
    <button type="submit" mat-raised-button>Iniciar sesión</button>
  </mat-card-actions>
</mat-card>
</form>
<div class="loading" *ngIf="(isLoading$ | async)">
  <mat-spinner></mat-spinner>
</div>


